/**
 * talk·point — Desktop Mega-Menü: Interaktion
 * ---------------------------------------------------------------------------
 * Hover-Intent (kein Flackern), „bleibt offen & morpht" beim Wechsel,
 * Backdrop-Dim, aktiver Zustand, Klick/Touch-Öffnen, Escape/Outside/Scroll-Close.
 * Bewusst import-frei. Steuert .tp-navitem.tp-has-mega über die Klasse .is-open;
 * das CSS zeigt/versteckt das Panel. Ohne JS bleibt Tastatur (:focus-within) nutzbar.
 */
(function () {
  if (window.__tpMegaInit) return;
  window.__tpMegaInit = true;

  var OPEN_DELAY = 110; // ms bis Öffnen (Absicht erkennen)
  var CLOSE_DELAY = 200; // ms bis Schließen (Weg zum Panel überbrücken)

  var items = Array.prototype.slice.call(document.querySelectorAll('.tp-navitem.tp-has-mega'));
  if (!items.length) return;

  var root = document.documentElement;
  var scrim = document.createElement('div');
  scrim.className = 'tp-mega-scrim';
  // In den Header hängen (dessen Stacking-Kontext), NICHT an <body> — sonst liegt
  // der Scrim über den Menüpunkten und fängt die Maus ab (Öffnungs-/Flacker-Bug).
  (document.querySelector('.tp-header') || document.body).appendChild(scrim);

  var openTimer = null;
  var closeTimer = null;
  var current = null;

  /**
   * Perf-Loop I7: Die Kachelbilder des Panels stehen nicht mehr als <img> im
   * Dokument (unsichtbar, aber Ballast auf jeder Seite), sondern als
   * data-tp-img-URL am Platzhalter-Span. Erst die Öffnungs-Absicht
   * (Hover-Intent, Klick oder Fokus) hängt die <img> ein. Kein Layout-Shift:
   * der Span hält seine Fläche über aspect-ratio; das Bild füllt sie nur.
   * Idempotent — data-tp-img wird nach dem Mount entfernt.
   */
  function hydrateMega(item) {
    var spans = item.querySelectorAll('[data-tp-img]');
    for (var i = 0; i < spans.length; i++) {
      var span = spans[i];
      var img = document.createElement('img');
      // Muss die Klasse mit der Fuellregel tragen (width/height 100 %, cover).
      // Mit einer ungestylten Klasse sass das 4:3-Bild zentriert im 4:3,1-Span
      // und liess oben und unten ~4 px des Tint-Gradienten frei — als farbige
      // Linie an der Kachel-Oberkante sichtbar (Talk-Point/IT#16838).
      img.className = 'tp-mega__img-el';
      img.alt = span.getAttribute('data-tp-alt') || '';
      img.src = span.getAttribute('data-tp-img');
      span.removeAttribute('data-tp-img');
      span.removeAttribute('data-tp-alt');
      span.appendChild(img);
    }
  }

  function open(item) {
    if (current === item) return;
    hydrateMega(item);
    if (current) {
      root.classList.add('tp-mega-switching');
      current.classList.remove('is-open');
      var pa = current.querySelector(':scope > a');
      if (pa) pa.setAttribute('aria-expanded', 'false');
    }
    item.classList.add('is-open');
    var a = item.querySelector(':scope > a');
    if (a) a.setAttribute('aria-expanded', 'true');
    current = item;
    root.classList.add('tp-mega-open');
  }

  function close() {
    if (current) {
      current.classList.remove('is-open');
      var a = current.querySelector(':scope > a');
      if (a) a.setAttribute('aria-expanded', 'false');
      current = null;
    }
    root.classList.remove('tp-mega-open');
    root.classList.remove('tp-mega-switching');
  }

  function scheduleOpen(item) {
    // Bilder schon während der Hover-Intent-Verzögerung anfordern — so sind sie
    // beim Aufklappen meist da, wie vorher mit serverseitigem <img>.
    hydrateMega(item);
    clearTimeout(closeTimer);
    clearTimeout(openTimer);
    // Wenn schon eins offen ist, nutzen wir eine kurze Absichts-Verzögerung (100ms),
    // um unbeabsichtigtes Überschlagen (Mouse-Sweeping) zu verhindern.
    var delay = current ? 100 : OPEN_DELAY;
    openTimer = setTimeout(function () {
      open(item);
    }, delay);
  }

  function scheduleClose() {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, CLOSE_DELAY);
  }

  items.forEach(function (item) {
    // Hover-Intent nur für Zeiger, die ruhen können (Maus, Trackpad, Stift).
    // Ein Finger hat keinen Ruhezustand: Touch feuert pointerenter beim
    // Aufsetzen und pointerleave direkt nach dem Loslassen — noch VOR dem
    // click. Der so gestartete Schließ-Timer klappte das per Tap geöffnete
    // Menü nach 200 ms wieder zu (iPad quer, Talk-Point/IT#16853). Für Touch
    // gilt deshalb allein das Klick-Modell im Link-Handler unten.
    item.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      scheduleOpen(item);
    });
    item.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'touch') return;
      scheduleClose();
    });
    // Tastatur: das Panel öffnet ohne JS-Klasse über :focus-within (CSS).
    // Die Bilder müssen deshalb auch am Fokus hängen, nicht nur an open().
    item.addEventListener('focusin', function () {
      hydrateMega(item);
    });

    var a = item.querySelector(':scope > a');
    if (a) {
      a.setAttribute('aria-haspopup', 'true');
      a.setAttribute('aria-expanded', 'false');
      // 1. Klick/Touch öffnet (statt zu navigieren); ist es schon offen, folgt der Link.
      a.addEventListener('click', function (e) {
        if (current !== item) {
          e.preventDefault();
          clearTimeout(openTimer);
          clearTimeout(closeTimer); // kein Rest-Timer darf das Geöffnete gleich wieder schließen
          open(item);
        }
      });
    }
  });

  // Panel selbst offen halten; Scrim schließt.
  scrim.addEventListener('pointerenter', close);
  scrim.addEventListener('click', close);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) close();
  });
  window.addEventListener(
    'scroll',
    function () {
      if (current) close();
    },
    { passive: true }
  );
  document.addEventListener('pointerdown', function (e) {
    if (current && !e.target.closest('.tp-navitem.tp-has-mega')) close();
  });

  /* ── Perf-Loop I7: Drawer-Akkordeon-Inhalte nachladen ─────────────────────
     Die Inhalte der Menü-Akkordeons (Toplist + Kachel-Grid) duplizierten 1:1
     die Links des Desktop-Mega-Menüs und standen trotzdem in jedem Dokument
     (~25 KB, ~320 Knoten). Jetzt rendert sie sections/tp-nav-drawer.liquid,
     geholt per Section-Rendering-API beim ersten Öffnen des Drawers.
     pointerdown auf dem Burger startet den Fetch schon vor dem click — bis der
     Nutzer ein Akkordeon antippt, ist die Antwort normalerweise da. Öffnet
     jemand schneller, füllt sich das Akkordeon beim Eintreffen (nutzer-
     initiiert, zählt nicht in CLS). Bei Fetch-Fehler wird beim nächsten
     Öffnen-Versuch erneut geladen. */
  var navLoaded = false;
  var navLoading = false;
  function fillDrawerNav() {
    if (navLoaded || navLoading) return;
    var slots = document.querySelectorAll('[data-tp-nav-slot]');
    if (!slots.length) {
      navLoaded = true;
      return;
    }
    navLoading = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?section_id=tp-nav-drawer')
      .then(function (res) {
        if (!res.ok) throw new Error('tp-nav-drawer ' + res.status);
        return res.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        for (var i = 0; i < slots.length; i++) {
          var slot = slots[i];
          var fill = doc.querySelector('[data-tp-nav-fill="' + slot.getAttribute('data-tp-nav-slot') + '"]');
          if (!fill) continue;
          while (fill.firstChild) slot.appendChild(fill.firstChild);
          slot.removeAttribute('data-tp-nav-slot');
        }
        navLoaded = true;
        navLoading = false;
      })
      .catch(function () {
        navLoading = false;
      });
  }
  // Capture-Phase, damit der Fetch vor Horizons on:click-Toggle startet;
  // pointerdown liegt zusätzlich ~100 ms vor dem click des Taps.
  function maybeFillDrawerNav(e) {
    if (e.target.closest && e.target.closest('[aria-controls="tp-menu"]')) fillDrawerNav();
  }
  document.addEventListener('pointerdown', maybeFillDrawerNav, true);
  document.addEventListener('click', maybeFillDrawerNav, true);
  // Theme-Editor: Section-Re-Render ersetzt den Drawer samt gefüllter Slots —
  // beim nächsten Öffnen neu laden statt auf leeren Akkordeons sitzen bleiben.
  document.addEventListener('shopify:section:load', function () {
    navLoaded = false;
  });

  // Mobile menu accordion: auto-collapse other categories when one is opened,
  // and reset all accordions to closed when the drawer is closed.
  var drawerMenu = document.querySelector('#tp-menu');
  if (drawerMenu) {
    // Fallback für jeden Öffnungsweg, der nicht über den Burger geht
    // (theme-drawer.js dispatcht das Event bei jedem open()).
    drawerMenu.addEventListener('theme-drawer:open', fillDrawerNav);
    var detailsList = Array.prototype.slice.call(drawerMenu.querySelectorAll('.tp-menu__details'));
    detailsList.forEach(function (det) {
      det.addEventListener('toggle', function () {
        if (det.open) {
          detailsList.forEach(function (other) {
            if (other !== det && other.open) {
              other.open = false;
            }
          });
        }
      });
    });

    drawerMenu.addEventListener('theme-drawer:close', function () {
      detailsList.forEach(function (det) {
        det.open = false;
      });
    });
  }
})();
